import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ItemsToSetUpListSubjectService {
  constructor() {}
  itemsToSetUpList: BehaviorSubject<Array<any>> = new BehaviorSubject([]);

  handleItemsToSetUpList(val: Array<any>) {
    this.itemsToSetUpList.next(val);
  }
}
